module.exports = __webpack_public_path__ + "static/media/brazil-flag.413d584a.svg";